import { __module as t } from "../../../_virtual/isLength.js";
import { a as o } from "./util/assertString.js";
!function (t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = function (t, o) {
    (0, r.default)(t), "object" === u(o) ? (e = o.min || 0, n = o.max) : (e = arguments[1] || 0, n = arguments[2]);
    var e,
      n,
      f = t.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [],
      l = t.length - f.length;
    return l >= e && (void 0 === n || l <= n);
  };
  var r = o && o.__esModule ? o : {
    default: o
  };
  function u(t) {
    return (u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  t.exports = e.default, t.exports.default = e.default;
}(t, t.exports);
var e = t.exports;
export { e as i };